/* eslint no-unused-vars: 0 */
import $ from 'jquery';

import initScrollTo from './scroll-to';
import MegaMenu from './mega-menu';
import Toggler from './toggler';
import ReadMore from './read-more';
import Video from './video';
import Carousel from './carousel';
import ImageGallery from './image-gallery';
import HeroVideo from "./hero-video";
import Header from "./header";

$(document).ready(() => {
    const $jsScrollTo = $('.js-scroll-to');
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    const jsMegaMenu = document.querySelectorAll('.js-mega-menu');
    if (jsMegaMenu.length) {
        [...jsMegaMenu].map((e) => MegaMenu(e))
    }

    const jsToggle = document.querySelectorAll('.js-toggle');
    if (jsToggle.length) {
        [...jsToggle].map((e) => Toggler(e))
    }

    const jsReadMore = document.querySelectorAll('.js-read-more');
    if (jsReadMore.length) {
        [...jsReadMore].map((e) => ReadMore(e))
    }

    const jsVideo = document.querySelectorAll('.js-video-preview');
    if (jsVideo.length) {
        [...jsVideo].map((e) => Video(e))
    }

    const jsCarousel = document.querySelectorAll('.js-carousel');
    if (jsCarousel.length) {
        [...jsCarousel].map((e) => Carousel(e))
    }

    const jsImageGallery = document.querySelectorAll('.js-image-gallery');
    if (jsImageGallery.length) {
        [...jsImageGallery].map((e) => ImageGallery(e))
    }

    const heroVideo = document.getElementById('js-hero-video');
    if (heroVideo) {
        HeroVideo(heroVideo);
    }

    const header = document.querySelector('.js-header');
    if (header) {
        Header(header);
    }
});
